import { z } from 'zod';

export const sprintPacketApprovalSchema = z.object({
  id: z.number(),
  packetID: z.number(),
  campaignID: z.string(),
  approvedByUserID: z.number(),
  approvedAt: z.string(),
  signature: z.string().nullish(),
  notes: z.string().nullish(),
});

export type SprintPacketApproval = z.infer<typeof sprintPacketApprovalSchema>;

export const CreateSprintPacketApprovalDTO = sprintPacketApprovalSchema.pick({
  campaignID: true,
  signature: true,
  notes: true,
});

export type CreateSprintPacketApproval = z.infer<
  typeof CreateSprintPacketApprovalDTO
>;
